import React from 'react';
import { useCurrency } from '../context/CurrencyContext';

export default function CurrencySwitcher() {
  const { currency, changeCurrency, loading } = useCurrency();

  const currencies = [
    { code: 'MYR', name: 'Malaysian Ringgit' },
    { code: 'USD', name: 'US Dollar' },
    { code: 'EUR', name: 'Euro' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'SGD', name: 'Singapore Dollar' },
    { code: 'THB', name: 'Thai Baht' },
    { code: 'IDR', name: 'Indonesian Rupiah' },
  ];

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-4 py-2 text-white hover:text-gray-300 transition-colors font-light tracking-wide">
        <span className="text-sm">{currency}</span>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </button>

      <div className="absolute right-0 mt-2 w-48 bg-black rounded-none shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 border border-white">
        <div className="p-4">
          {loading && <p className="text-xs text-gray-400 px-3 py-2">Updating rates...</p>}
          {currencies.map(curr => (
            <button
              key={curr.code}
              onClick={() => changeCurrency(curr.code)}
              className={`w-full text-left px-3 py-2 text-sm transition-all font-light ${
                currency === curr.code 
                  ? 'text-white bg-gray-900' 
                  : 'text-gray-300 hover:text-white hover:bg-gray-900'
              }`}
            >
              <span>{curr.code}</span>
              <span className="text-xs ml-2 text-gray-500">{curr.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
